// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TimeRoundSvg from '@rsuite/icon-font/lib/status/TimeRound';
var TimeRound = createSvgIcon({
  as: TimeRoundSvg,
  ariaLabel: 'time round',
  category: 'status',
  displayName: 'TimeRound'
});
export default TimeRound;